export default "__VITE_ASSET__BmtkV9ig__"